import { useEffect, useState, useRef } from "react";
import { ReactTable, SafeButton,  BooleanColumnFilter, BooleanFilterType} from "../common";
import { Message } from "semantic-ui-react";
import { canEditAll, getCSRFToken, fetchWithAuth } from "../auth";
import { LoadingWrapper } from "../common";
import "../../css/members.css"
import { AddDeviceSubTypesModal } from "./AddDeviceSubTypes";
import { Link } from "react-router-dom";


export const DeviceSubTypes = (props) => {
  const [deviceSubTypes, setDeviceSubTypes] = useState([])
  const [columnInfo, setColumnInfo] = useState([])
  const [loaded, setLoaded] = useState(false)
  const selectedRef = useRef({})
   const [error, setError] = useState('')
  const [success, setSuccess] = useState('')


  async function getDeviceSubTypes() {
    setLoaded(false)
    const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'devicesubtypes/', {
      headers: { 'X-CSRFToken': getCSRFToken() },
      credentials: 'include'
    })
    let respJson = await resp.json()
    respJson.forEach(devSubType => {
      devSubType["checklistExists"] = !(devSubType.checklist === null)
    })
    setDeviceSubTypes(respJson)
    setLoaded(true)
  }

  function updateSelected(ev) {
    selectedRef.current = { ...selectedRef.current, ...ev }
  }

  useEffect(() => {
    getDeviceSubTypes()
  }, [])

  async function deleteSelectedDeviceSubTypes() {
    setError('')
    setSuccess('')
    let errored = []
    async function deleteDeviceSubTypes(deviceSubtypeId, devicesubtypeName) {
      const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'devicesubtypes/' + deviceSubtypeId + '/',
        {
          method: "DELETE",
          headers: { 'X-CSRFToken': getCSRFToken() },
          credentials: 'include'
        }
      )
       if (resp.status > 399){
        errored.push(devicesubtypeName)
      }
    }
    for (const deviceSubtypeIndex in selectedRef.current) {
      try {
        const toDelete = selectedRef.current[deviceSubtypeIndex]
        if (toDelete) {
          const deviceSubtypeId = deviceSubTypes[deviceSubtypeIndex].id
          const deviceSubtypeName = deviceSubTypes[deviceSubtypeIndex].name
          await deleteDeviceSubTypes(deviceSubtypeId, deviceSubtypeName)
        }
      } catch { }  // some deleted member from earlier still in the state
    }
    if (errored.length>0){
      setError("Failed to delete: "+ errored)
    }else{
      setSuccess("Successfully deleted asset subtype.")
    }
    selectedRef.current = {}
    getDeviceSubTypes()
  }

  function deleteDeviceSubTypes() {
    deleteSelectedDeviceSubTypes()
  }


  useEffect((isEdit) => {
    setColumnInfo([
      {
        Header: "Asset SubType",
        accessor: "name",
        Cell: (row) => {
          return <Link to={"/devicesubtypes/" + row.row.original.id}>{row.row.original.name}</Link>
        }
      },
      {
        Header: "ID",
        accessor: "id"
      },
      {
        Header: "Device Type",
        accessor: "assetDeviceType.name",
        Cell: (row) => {

          return <div>{row.row.original.assetDeviceType.name}</div>


        }
      },
      {
        Header: "Checklist",
        accessor: "checklistExists",
        Filter: row => BooleanColumnFilter(row, "Checklist", "No Checklist"),
        filter: BooleanFilterType,
        Cell: (row) => {
        if (row.row.original.checklist) {
          return <Link to={"/devicesubtypes/" + row.row.original.id + "/checklist"}>Checklist</Link>
        } else {
          return <div style={{color: "darkgray"}}>No Checklist</div>
        }
        }
      }
    ])
  }, [])

  return (
    <div>
      {error !== '' &&
        <Message style={{ width: "fit-content" }} compact negative>{error}</Message>
      }
      {success !== '' &&
        <Message style={{ width: "fit-content" }}  compact positive>{success}</Message>
      }
      <LoadingWrapper loading={!loaded} text="Loading Asset Subtypes">
        <ReactTable
          className="channel-table"
          data={deviceSubTypes}
          columns={columnInfo}
          hiddenColumns={['id']}
          editable={canEditAll()}
          setEdit={updateSelected}
        />
        {canEditAll() && <div style={{ paddingBottom: "2rem", paddingTop: "1rem" }}>
          <AddDeviceSubTypesModal refresh={getDeviceSubTypes} deviceSubTypes={deviceSubTypes} />
          <SafeButton style={{backgroundColor: "var(--delete)", color: "white"}} submitAction={deleteDeviceSubTypes} submitText="Delete selected" />
        </div>}
      </LoadingWrapper>
    </div>
  );
}